import api from "./api";
import {
  classifyVerificationError,
  type VerificationError,
} from "./verificationErrors";
import { gvmBouncerPath, gvmPath } from "./apiPaths";

export { isValidPanFormat } from "./validators";

const ENDPOINT_NAME = "/pan-name";

export type PanLookupResult = {
  valid: boolean;
  legalName: string | null;
};

export type PanLookupError = VerificationError;

export type PanLookupAuthMode = "vendor" | "bouncer";

export async function lookupPanName(
  pan: string,
  opts: { auth?: PanLookupAuthMode } = {},
): Promise<PanLookupResult> {
  const auth = opts.auth ?? "vendor";
  const url =
    auth === "vendor" ? gvmPath(ENDPOINT_NAME) : gvmBouncerPath(ENDPOINT_NAME);
  const config = auth === "vendor" ? { useVendorToken: true } : {};
  const res = (await api.post(url, { pan }, config)) as
    | { valid?: boolean; legal_name?: string }
    | null;
  return {
    valid: Boolean(res?.valid),
    legalName: typeof res?.legal_name === "string" ? res.legal_name : null,
  };
}

export function classifyPanLookupError(err: unknown): PanLookupError {
  return classifyVerificationError(err, "pan");
}
